import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { classItem } from '@models/classItem';
import { FormBuilder } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from '@services/auth.service';
import { AlertifyService } from '@services/alertify.service';
import { ClassService } from '@services/class.service';
import { QuizService } from '@services/quiz.service';
import { ChangeDetectorRef } from '@angular/core';
import { UserClassesTaken } from '@models/user-classes-taken';
import { UserClassesService } from '@services/user-classes.service';
import { UserClassesStateService } from '@services/user-classes-state.service';
import { QuizQuestion } from '@models/quiz-question';
import { NgbActiveModal, NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { ElementRef } from '@angular/core';
import { Subscription, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { lessThanAsyncValidatorExtension } from '@rxweb/reactive-form-validators/validators-extension';
import { MatDialog } from '@angular/material/dialog';
import { PopupComponent } from '@components/popup/popup.component';
import { ConfigurationService } from '@services/configuration.service';
import { CourseCompletionModalComponent, CompletionStats } from '@shared/components/course-completion-modal/course-completion-modal.component';
import { CourseProgressService } from '@services/course-progress.service';


@Component({
  selector: 'app-quiz',
  templateUrl: './quiz.component.html',
  styleUrls: ['./quiz.component.css']
})
export class QuizComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();

  classId: number;
  class: classItem; // class 1 , class 2 ...
  quizQuestions: any; // Can be single QuizQuestion or array depending on API response
  quizQ: QuizQuestion;
  previousQuestion: string;
  //scores = new Map<string, number>();
  correctAnswers = new Map(); // map javascript dictionary
  listAnswers = new Map(); // aswers selected by the studers //   map javascript dictionary
  listQuizError = new Map(); // list that contains all quizzes and the state:  true or false (correct / incorrect)
  quizcompleted = false;
  videocompleted = true;
  handoutcomplete = true;
  userClassesCompleted: boolean[] = [false, false, false, false, false, false, false, false, false, false];
  lockout: boolean = false;

  quizError = false; //check if there is an error in the quiz
  userClasses: UserClassesTaken; // update quiz completed
  closeResult: string; // temp modalpopup
  show = false;
  //private fragment: string;
  private scrollExecuted: boolean = false;
  pageErrorsText: string = "";
  currentQuestionNumber: number = 0; // to show the question number
  count: number = 0; // to count the questions
  

  @ViewChild('content', { static: true }) modalCourse: any;
  //@ViewChild('content') myModal: any;
  
  content: any;

  constructor(
    private fb: FormBuilder, 
    private router: Router,
    public authService: AuthService, 
    private alertify: AlertifyService,
    private actRoute: ActivatedRoute, 
    public classService: ClassService,
    public quizService: QuizService, 
    private cdref: ChangeDetectorRef,
    public userClassesService: UserClassesService, 
    private userClassesStateService: UserClassesStateService,
    private modalService: NgbModal, 
    private dialogRef : MatDialog,
    private configurationService: ConfigurationService, 
    private progressService: CourseProgressService
  ) { }
    

  ngOnInit() {
    this.classId = parseInt(this.actRoute.snapshot.params['id'], 10); // must convert to numeric

    // Initialize user classes state
    this.userClassesStateService.loadUserClasses().pipe(takeUntil(this.destroy$)).subscribe();
    
    // Subscribe to current class state for pre-validation
    this.userClassesStateService.userClasses$.pipe(takeUntil(this.destroy$)).subscribe(classes => {
      const currentClass = classes.find(cls => cls.classId === this.classId);
      if (currentClass) {
        this.videocompleted = currentClass.isVideoCompleted;
        this.handoutcomplete = currentClass.isHandoutCompleted;
        this.quizcompleted = currentClass.isQuizCompleted;
      }
    });

    // Subscribe to course progress for completion detection
    this.progressService.progress$.pipe(takeUntil(this.destroy$)).subscribe(progress => {
      if (progress.isComplete && this.authService.getCourseCompleted() === "false") {
        this.alertify.success('You have completed the course Intercessory Prayer!');
        this.authService.setCourseCompleted();
        
        // Show completion modal
        setTimeout(() => this.showCompletionModal(), 1000);
      }
    });

    this.getQuiz(this.classId);
    this.listQuizError.set(1, false);  //have to intilize values 
    this.listQuizError.set(2, false);
  }

  ngAfterViewChecked() {
   // this.listQuizError.detectChanges();
    this.cdref.detectChanges(); // avoid error : ExpressionChangedAfterItHasBeenCheckedError: Expression has changed after it was checked. Previous value: 'undefined'
                                // on: *ngIf="checkErrorQuestion(quiz.quizId)"
                                
    if (!this.scrollExecuted) {
      setTimeout(() => { 
        const topElement = document.getElementById('top');
        if (topElement) {
          topElement.scrollIntoView();
        }
      }, 100);
      this.scrollExecuted = true;
    }

  }

  ngAfterViewInit(): void {
    const topElement = document.getElementById('top');
    if (topElement) {
      topElement.scrollIntoView();
    }
  }
  /*
  scroll(sectionId) {
    let element = document.getElementById(sectionId);
    
      if(element) {
        element.scrollIntoView(); // scroll to a particular element
      }
     }
     */

  // create a list with correct answers 
  addCorrectAnswer(quizId: number , correctAnswer: string ) {
    // correct answer for the quizz
    this.correctAnswers.set(quizId, correctAnswer);
    //this.listQuizError.set(quizId, false); // create a list of errors (state) for each quiz

    for (let [key, value] of this.correctAnswers) {
      // console.log(key + ' = ' + value)
    }

    //console.log(this.correctAnswers.size);
  }

  getClass(id: number) {
    this.classService.getClassById(id).subscribe((classValue: classItem) => {
      this.class = classValue; // class 1, 2..
      console.log(this.class);
    }, error => {
      this.alertify.error(error);
    }, () => { // third part , complete
      //set default country
      //get Url from dataBase
    }
    );
  }

  getQuiz(id: number) {
    this.quizService.getQuiz(id).subscribe((quizQs: QuizQuestion) => {
      this.quizQuestions = quizQs; // class 1, 2..
      console.log("Quiz Questions: ", this.quizQuestions);

      // console.log(this.quizQuestions);
     // console.log(this.quizQuestions);
    }
    // , error => {
    //   this.alertify.error(error);
    // }
    // , () => { // third part , complete
    //   //set default country
    //   //get Url from dataBase
    // }
    );
    //this.quizQuestions = quizQuestions;
  }

  // when iteration quizzes, do not write the same question  
  updateQuestion(question : string) {
    this.previousQuestion = question; 
  }

  addStudentAnswer(quizQuestionId: number, studentAnswer) {
    // e.target.value
    this.listAnswers.set(quizQuestionId, studentAnswer.target.value);
  }

  validateQuiz() {

   
    //let progress: number;
    //this.userClassesService.returnProgress(progress, this.authService.returnCurrentUser().id);

    //return;

    // clean the variables from the last validation 
    this.quizcompleted = false;
    this.quizError = false;
    for (let [keyQuiz, value] of this.correctAnswers) {
      //console.log('question: ' + keyQuiz);

      //console.log('key stude: ' + this.listAnswers.get(keyQuiz));
      //console.log('value:' + value);

      // to compare to object they must be converted to String 
      if (String(this.listAnswers.get(keyQuiz)) != String(value)) {
        this.quizError = true;
        this.listQuizError.set(keyQuiz, true);
      }
      else {
        this.listQuizError.set(keyQuiz, false);
      }
     // this.cdref.detectChanges();
      //console.log('this.listQuizError.get(' + keyQuiz + ') : ' + this.listQuizError.get(keyQuiz));
    }

    if (this.quizError == false) {
      this.quizcompleted = true;  
      this.pageErrorsText = "You must wait 7 days after completing this quiz before accessing the next class." +
                            // "You will be able to access the next activity at: " + nextDate.toLocaleString();";      
      this.updateQuizCompleted();

    }
  }

  openDialog() {
    this.dialogRef.open(PopupComponent, {
      data : {
        pageErrorsText : this.pageErrorsText
    }
  });
}

  checkErrorQuestion(quizQuestionId: number) {
   // console.log('checking : ' + quizQuestionId + ' - ' + this.listQuizError.get(quizQuestionId));

    return this.listQuizError.get(quizQuestionId);
  }

  //This is what routes the user to the next video
  continue() {
    // go to the next video
    let nextVideo = 0;
    nextVideo = +this.classId + +1;
    //console.log('nextVideo' + nextVideo);
    if (nextVideo != 11) {
      this.router.navigate(['/app/classes']);
      // this.router.navigate(['/video', nextVideo]);
    }
  }

  updateQuizCompleted() {
    // Get current class state for proper data preservation
    const currentClassData = this.userClassesStateService.getClassById(this.classId);
    
    if (!currentClassData) {
      this.alertify.error('Unable to find class data. Please try again.');
      return;
    }

    this.userClasses = {
      ...currentClassData, // Preserve all existing data
      isQuizCompleted: true, // Only update quiz completion
    };
    
    console.log("Updating quiz completed for user:", this.userClasses);

    // Step 1: Update quiz completion status
    this.userClassesService.UpdateUserClassesTakenVideoCompleted(this.userClasses).subscribe({
      next: (response) => {
        // Step 2: Use the simplified service method for completion checking
        this.userClassesStateService.checkAndUpdateCourseCompletion().subscribe({
          next: (completionResult) => {
            console.log(`Course completion check: ${completionResult.completed}/30 activities completed`);
            
            if (completionResult.isFullyComplete) {
              this.alertify.success('You have completed the course Intercessory Prayer!');
              // The completion modal will be triggered by the CourseProgressService subscription
            }
          },
          error: (error) => {
            console.error('Course completion check failed:', error);
          }
        });

        // Refresh state to trigger automatic progress update (for UI updates)
        this.userClassesStateService.refreshUserClasses();
      },
      error: (error) => {
        this.alertify.error('Failed to update quiz completion');
        console.error('Quiz update error:', error);
      }
    });
  }

  private showCompletionModal(): void {
    const stats: CompletionStats = {
      completionDate: new Date(),
      classesCompleted: this.configurationService.totalClasses,
      totalClasses: this.configurationService.totalClasses
    };
  
    const modalRef = this.modalService.open(CourseCompletionModalComponent, {
      backdrop: 'static',
      keyboard: false,
      centered: true,
      size: 'md'
    });
  
    modalRef.componentInstance.stats = stats;
  
    modalRef.result.then((result) => {
      if (result === 'certificate') {
        this.router.navigate(['/app/dashboard']);
      }
    }).catch(() => {
      // Modal dismissed
    });
  }


  //Function to lock users out of classes where all previous classes have not been completed
  UserClassesCompleted() {
    // Use state service to check class completion status
    this.userClassesStateService.userClasses$.pipe(takeUntil(this.destroy$)).subscribe(classes => {
      // Convert to boolean array for lockout logic
      this.userClassesCompleted = classes.map(cls => 
        cls.isVideoCompleted && cls.isHandoutCompleted && cls.isQuizCompleted
      );
      
      // Check if user can access current class (must complete all previous classes)
      if (this.classId != 1) {
        this.lockout = false; // Reset lockout
        for (let i = 0; i < (this.classId - 1); i++) {
          if (!this.userClassesCompleted[i]) {
            this.lockout = true;
            break;
          }
        }
      }

      // Redirect if locked out
      if (this.lockout) {
        this.alertify.error('You must complete all previous classes before accessing this quiz.');
        this.router.navigate(['/app/classes']);
      }
    });
  }

  open(content) {
    //const modalRef = this.modalService.open(QuizComponent);
   // modalRef.componentInstance.name = 'World';

    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  linkToHint(question: string) {
    //alert(this.classId + " <-> " + Number(question.charAt(0)));

    return 'assets/handout/Session_' + this.classId + '_Handout_Online.pdf';

  }

  // New method for quiz progress tracking
  getQuizProgress(): number {
    if (!this.quizQuestions || !Array.isArray(this.quizQuestions) || this.quizQuestions.length === 0) {
      return 0;
    }
    
    const totalQuestions = this.quizQuestions.length / 4;//Quick-Fix Bandaid -- when Databases are refactored, then this line should no longer need the divided by 5...
    const answeredQuestions = this.listAnswers.size;
    
    return Math.round((answeredQuestions / totalQuestions) * 100);
  }

    getVisibleQuestionNumber(quiz_question: number): number {
    // let count = 0;
    // for (let i = 0; i <= index; i++) {
    //   if (this.previousQuestion != this.quizQuestions[i].question) {
    //     count++;
    //   }
    // }
    /*{{ getVisibleQuestionNumber(quizQuestion.quizQuestionId) }}*/
    console.log("Current Question Number: " + this.currentQuestionNumber);
    console.log("Quiz Question: " + quiz_question);
    if (this.currentQuestionNumber != 0 && this.currentQuestionNumber != quiz_question) {
      this.count++;
      console.log("incrementing count: " + this.count);
    }
    this.currentQuestionNumber = quiz_question;

    return this.count;
  }
  
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}


